import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '@/Layout.vue';
import Auth from '@/views/Auth.vue';
import Dashboard from '@/views/Dashboard.vue';
import CalendarView from "@/views/CalendarView.vue";
import MyCardDecks from "@/views/MyCardDecks.vue";

import store from '@/store';
import error404 from '@/views/Errors/404.vue';
import TeamMembers from "@/views/TeamMembers.vue";
import CommunityLibrary from "@/views/CommunityLibrary.vue";
import CardDeckCardsList from "@/views/CardDecks/CardDeckCardsList.vue";
import Account from "@/views/Account.vue";
import Heroes from "@/views/Heroes/Heroes.vue";
import HeroDetails from "@/views/Heroes/HeroDetails.vue";
import CardDeckFavorites from "@/views/CardDecks/CardDeckFavorites.vue";
import Terms from "@/views/Terms.vue";


Vue.use(VueRouter);

const routes = [
  { path: '/login', name: 'login', component: Auth, meta: { rule: 'isPublic' } },
  { path: '/register', name: 'register', component: Auth, meta: {rule: 'isPublic' }},
  { path: '/404', name: '404', component: error404, meta: { title: '404 - not found' } },
  {
    path: '/auth/:provider/callback',
    component: {
      template: '<div class="auth-component"></div>'
    }
  },
  {
    path: '/',
    component: Layout,
    children: [
      { path: '', name: 'home', component: Dashboard, meta: { title: 'Dashboard', rule: 'isLogged' } },
      { path: 'card-decks', name: 'card.decks', component: MyCardDecks, meta: { title: 'My Card Decks', rule: 'isLogged' } },
      { path: 'calendar', name: 'calendar', component: CalendarView, meta: { title: 'Calendar', rule: 'isLogged' } },
      { path: 'team', name: 'team', component: TeamMembers, meta: { title: 'TeamMembers', rule: 'isLogged' } },
      { path: 'heroes', name: 'heroes', component: Heroes, meta: { title: 'Heroes', breadcrumb: true, rule: 'isLogged' } },
      { path: 'heroes/details/:hero_id', name: 'hero.details', component: HeroDetails, meta: {title: 'Hero Details', breadcrumb: { label: 'Hero Details', parent: 'heroes' }, rule: 'isLogged' } },
      { path: 'community-library', name: 'community.library', component: CommunityLibrary, meta: { title: 'Card Deck Library', rule: 'isLogged' } },

      { path: 'card-deck-cards/:id', name: 'card.deck.cards', component: CardDeckCardsList, meta: { title: 'Card Deck Cards', breadcrumb: { parent: 'community-library' }, rule: 'isLogged' } },
      { path: 'card-deck-favorites', name: 'card.deck.favorites', component: CardDeckFavorites, meta: { title: 'Card Deck Favorites', breadcrumb: { parent: 'community-library' }, rule: 'isLogged' } },

      { path: 'account', name: 'account', component: Account, meta: { title: 'My account', breadcrumb: true, rule: 'isLogged' } },
      { path: 'terms', name: 'terms', component: Terms, meta: { title: 'Terms and Conditions', breadcrumb: true, rule: 'isLogged' } },

      // { path: 'users/', name: 'users.list', component: UsersList, meta: { title: 'Users', breadcrumb: true, rule: 'isLogged' } },
      // { path: 'users/add', name: 'users.create', component: UsersForm, meta: { title: 'Add User', breadcrumb: { parent: 'users.list' }, rule: 'isLogged' } },
      // { path: 'users/edit/:uid', name: 'users.edit', component: UsersForm, meta: { title: 'Edit User', breadcrumb: { parent: 'users.list' }, rule: 'isLogged' } },
    ],
    meta: {
      isMain: true,
      rule: 'isLogged',
    },
  },
  { path: '*', component: error404, meta: { title: '404 - not found' } },
];

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta) {
    store.commit('setMeta', to.meta);
    if (to.meta.title) {
      document.title = `MagnusTeams Panel | ${to.meta.title}`;
    } else {
      document.title = 'MagnusTeams Panel';
    }
  }

  next();
});

export default router;
